import { TYPE_CHAR, TYPE_PRE } from "../../constants/index";

export const getCrossword = state => state.crossword;
export const getLoading = state => getCrossword(state).loading;
export const getLoaded = state => getCrossword(state).loaded;
export const getShowHints = state => getCrossword(state).hints;
export const getSeed = state => getCrossword(state).seed;
export const getLevel = state => getCrossword(state).level;
export const getLang = state => getCrossword(state).lang;
export const getId = state => getCrossword(state).id;
export const getSize = state => getCrossword(state).size;
export const getNext = state => getCrossword(state).next;
export const getNextLevel = state => getNext(state).level;
export const getNextSeed = state => getNext(state).seed;
export const getPrizes = state => getCrossword(state).prizes;
export const getAlphabet = state => getCrossword(state).alphabet;
export const getSolved = state => getCrossword(state).solved;
export const getSecret = state => getCrossword(state).secret;
export const getData = state => getCrossword(state).data;
export const getValues = state => getCrossword(state).values;
export const getFocus = state => getCrossword(state).focus;
export const getPrevFocus = state => getCrossword(state).prevFocus;
export const getCell = (state, x, y) =>
  getData(state).find(cell => cell.x === x && cell.y === y);
export const getCellChar = (state, x, y) => getCell(state, x, y).char;
export const getValue = (state, x, y) =>
  getValues(state)[x] && getValues(state)[x][y] ? getValues(state)[x][y] : "";
export const isOfType = (state, x, y, type) =>
  (getData(state).find(cell => cell.x === x && cell.y === y) || {}).type ===
  type;
export const isChar = (state, x, y) => isOfType(state, x, y, TYPE_CHAR);
export const isPrefilled = (state, x, y) => isOfType(state, x, y, TYPE_PRE);
export const isFocusable = (state, x, y) =>
  isChar(state, x, y) || isPrefilled(state, x, y);
export const isCorrect = (state, x, y) =>
  getValue(state, x, y) === getCellChar(state, x, y);
export const hasValue = (state, x, y) => Boolean(getValue(state, x, y));
export const hadFocus = (state, x, y) =>
  getPrevFocus(state).x === x && getPrevFocus(state).y === y;
export const hasFocus = (state, x, y) =>
  getFocus(state).x === x && getFocus(state).y === y;



// WEBPACK FOOTER //
// ./src/reducers/crossword/selectors.js